import React from 'react';
import Burger from '../burger/burger';
import Button from '../common/CommonButton/Button';
import classes from './checkoutsummary.module.css';
import Wrapper from '../../wrapper/Wrapper';


const CheckoutSummary = (props) => {
    let showButtons = null;
    if(props.shouldShow){
        showButtons = (
            <Wrapper>
                <Button type="Danger" clicked={props.goBack}>CANCEL</Button>
                <Button type="Success" clicked={props.openForms}>CONTINUE</Button>
            </Wrapper>
        );
    }
    return (
    <div className={classes.CheckoutSummary}>
        <h1>Hope it tastes good!</h1>
        <Burger ingredients={props.ingredients}/>
        {showButtons}
    </div>
    );
}

export default CheckoutSummary;